/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.KCMO.Title',
    defaultMessage: 'KCMO',
  },
});

export default messages;
